import { render, staticRenderFns } from "./label-modal.vue?vue&type=template&id=11ad98d4&scoped=true"
import script from "./label-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./label-modal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ad98d4",
  null
  
)

export default component.exports